var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.728 2H3.176A1.16 1.16 0 0 0 2 3.144v13.712A1.16 1.16 0 0 0 3.176 18h13.552a1.16 1.16 0 0 0 1.176-1.144V3.144A1.16 1.16 0 0 0 16.728 2ZM6.824 15.392h-2.4v-7.2h2.4v7.2Zm-1.2-8.208a1.248 1.248 0 1 1 0-2.496 1.256 1.256 0 1 1 0 2.496Zm9.856 8.208h-2.4v-3.864c0-.968-.344-1.6-1.216-1.6a1.32 1.32 0 0 0-1.232.872c-.063.188-.09.386-.08.584v4h-2.4v-7.2h2.4V9.2A2.4 2.4 0 0 1 12.72 8c1.6 0 2.76 1.032 2.76 3.248v4.144Z",
    fill: "currentColor"
  })));
};

export default SvgLinkedIn;